<template>
  <v-form ref="loyaltyTierForm" v-model="valid">
    <v-layout style="width: 100%" row wrap>
      <v-flex xs12>
        <h4 class="grey--text text--darken-1">Loyalty Tier</h4>
      </v-flex>
      <v-flex xs6 md2 px-2>
        <v-text-field
          :error-messages="errorForField('name')"
          :rules="loyaltyTierRules.name"
          v-model="loyaltyTier.name"
          label="Name"
          @input="resetError('name')"
        />
      </v-flex>
      <v-flex xs6 md4 px-2>
        <v-text-field
          :error-messages="errorForField('description')"
          :rules="loyaltyTierRules.description"
          v-model="loyaltyTier.description"
          label="Description"
          @input="resetError('description')"
        />
      </v-flex>
      <v-flex xs6 md3 px-2>
        <FileInput
          label="Image"
          icon="photo_camera"
          accept="image/*"
          :required="true"
          @fileInput="handleImageInput"
          :errorMessage="errorForField('image')"
          :rules="loyaltyTierRules.image"
        />
      </v-flex>
      <v-flex xs3 md2 pl-3 pr-2 pt-2>
        <v-switch v-model="loyaltyTier.enabled" color="primary" label="Enabled" />
      </v-flex>
      <v-flex xs3 md2 pl-3 pr-2 pt-2>
        <v-text-field
          :error-messages="errorForField('point_threshold')"
          v-model="loyaltyTier.point_threshold"
          type="number"
          class="noStepNumber"
          label="Point Threshold"
          @input="resetError('point_threshold')"
        />
      </v-flex>
      <v-flex xs3 md2 pl-3 pr-2 pt-2>
        <v-text-field
          :error-messages="errorForField('multiplier_percentage')"
          :rules="loyaltyTierRules.multiplier_percentage"
          v-model="loyaltyTier.multiplier_percentage"
          type="number"
          class="noStepNumber"
          label="Multiplier Percentage"
          @input="resetError('multiplier_percentage')"
        />
      </v-flex>
      <v-flex xs8></v-flex>
      <v-col>
        <v-flex pl-3 pr-2 pt-2>
          <SelectableColorPicker
            :color="loyaltyTier.primary_color"
            label="Primary Color"
            @input="function(e){
            loyaltyTier.primary_color = e;
          }"
          />
        </v-flex>
        <v-flex pl-3 pr-2 pt-2>
          <SelectableColorPicker
            :color="loyaltyTier.progress_color"
            label="Progress Color"
            @input="function(e){
            loyaltyTier.progress_color = e;
          }"
          />
        </v-flex>
        <v-flex pl-3 pr-2 pt-2>
          <SelectableColorPicker
            :color="loyaltyTier.progress_background_color"
            label="Progress Background Color"
            @input="function(e){
            loyaltyTier.progress_background_color = e;
          }"
          />
        </v-flex>
        <v-flex pl-3 pr-2 pt-2>
          <SelectableColorPicker
            :color="loyaltyTier.tier_description_color"
            label="Tier Description Color"
            @input="function(e){
            loyaltyTier.tier_description_color = e;
          }"
          />
        </v-flex>
        <v-flex pl-3 pr-2 pt-2>
          <SelectableColorPicker
            :color="loyaltyTier.current_points_color"
            label="Current Points Color"
            @input="function(e){
            loyaltyTier.current_points_color = e;
          }"
          />
        </v-flex>
        <v-flex pl-3 pr-2 pt-2>
          <SelectableColorPicker
            :color="loyaltyTier.current_points_title_color"
            label="Current Points Label Color"
            @input="function(e){
            loyaltyTier.current_points_title_color = e;
          }"
          />
        </v-flex>
        <v-flex pl-3 pr-2 pt-2>
          <SelectableColorPicker
            :color="loyaltyTier.background_color"
            label="Background Color"
            @input="function(e){
            loyaltyTier.background_color = e;
          }"
          />
        </v-flex>  <v-flex pl-3 pr-2 pt-2>
          <SelectableColorPicker
            :color="loyaltyTier.background_color"
            label="Background Color"
            @input="function(e){
            loyaltyTier.background_color = e;
          }"
          />
        </v-flex>
         <v-flex pl-3 pr-2 pt-2>
          <SelectableColorPicker
            :color="loyaltyTier.background_color_gradient_start"
            label="Background Color Gradient Start"
            @input="function (e) {
                loyaltyTier.background_color_gradient_start = e;
              }
            "
          />
        </v-flex>
        <v-flex pl-3 pr-2 pt-2>
          <SelectableColorPicker
            :color="loyaltyTier.background_color_gradient_end"
            label="Background Color Gradient End"
            @input="function (e) {
                loyaltyTier.background_color_gradient_end = e;
              }
            "
          />
        </v-flex>
      </v-col>
    </v-layout>
  </v-form>
</template>

<script>
    import FileInput from "@/components/widget/input/FileInput.vue";
    import SelectableColorPicker from "@/components/widget/input/SelectableColorPicker.vue";

export default {
  name: "loyalty_tier_form",
  components: {
    FileInput,
    SelectableColorPicker
  },
  props: {
    loyaltyTier: Object,
    disabled: Boolean,
    errors: { type: Object, default: () => {} }
  },
  data: function() {
    return {
      valid: false,
      loyaltyTierRules: {
        name: [
          v => !!v || "Name is required",
          v => v.length <= 50 || "Name must be less than 200 characters"
        ],
        description: [
          v => !!v || "Description is required",
          v => v.length <= 200 || "Description must be less than 200 characters"
        ],
        image: [
          v => (this.loyaltyTier.picture ? true : !!v || "Image is required")
        ],
        multiplier_percentage: [
          v => !!v || "Multiplier Percentage required",
          v =>
            /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid multiplier (> 0)"
        ]
      }
    };
  },
  methods: {
    errorForField: function(field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function(field) {
      try {
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function() {
      this.$refs.loyaltyTierForm.validate();
    },
    handleImageInput: function(file) {
      this.resetError("image");
      this.$emit("imageInput", file);
    }
  },
  watch: {
    valid: function() {
      this.$emit("validityChange", this.valid);
    }
  }
};
</script>

<style>
    .noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>